import { linkToPhotoPage } from "routes/photo/links";

function linkToReport() {
  return `${linkToPhotoPage()}/report`;
}

export function linkToReportFunctionSelect() {
  return linkToReport();
}

export function linkToReportItemsList(fn: string = ":fn") {
  return `${linkToReport()}/items/${fn}`;
}

export function linkToReportOverview() {
  return `${linkToReport()}/overview`;
}

export function linkToReportUpload() {
  return `${linkToReport()}/upload`;
}
